/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var QuoteBillingCycleEnum;

(function (QuoteBillingCycleEnum) {
  QuoteBillingCycleEnum["ANNUAL"] = "annual";
  QuoteBillingCycleEnum["MONTHLY"] = "monthly";
  QuoteBillingCycleEnum["SEMI_ANNUAL"] = "semi_annual";
  QuoteBillingCycleEnum["QUARTERLY"] = "quarterly";
})(QuoteBillingCycleEnum || (QuoteBillingCycleEnum = {}));